<div class="layout-col full">
  <span style="width: 90vw"></span>

  <app-capability-spec-detail class="flex" [capabilitySpec]="capability" (close)="onClose($event)">
  </app-capability-spec-detail>
</div>
